import $ from 'jquery';
import {View} from 'backbone';
import eventBus  from 'EventBus.js';
import constants from 'Constants.js';
import _template from 'dashboard/forms/edit-forms-dashboard.ejs';
import RestService from 'RestService.js'

class EditFormsDashboardView extends View {

    className(){
        return 'EditFormsDashboardView';
    }

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.events = {
            'click #recentEditsEFD > ul > li' : 'showFormDetails',
            'click #ddFrmDashInstances > li' : 'showInstanceDetail',
            'click #lstFrmDashInstances span.detFormInstance' : 'getViewByInstance',
            'click .listSelected > ul > li' : 'showFormInfo', 
            'click #goToForms': 'goToForms'
        };

        return this;
    }

    getViewByInstance(ev){
        eventBus.trigger('loadViewByInstance', ev);
    }

    showFormDetails(ev) {
        const formId = ev.currentTarget.attributes["data-id"].value;
        eventBus.trigger('newInstance', formId);
    }

    showInstanceDetail(ev) {
        const formId = ev.currentTarget.attributes["formid"].value;
        if(formId==='all'){
            RestService.setSelectedFormInEditFormDashboard('all');
            eventBus.trigger('getAllFormInstance', ev.currentTarget);
        }else{
            RestService.setSelectedFormInEditFormDashboard(formId);
            eventBus.trigger('getFormInstance', formId, ev.currentTarget);
        }

    }
    showFormDetails(ev) {
        const formId = ev.currentTarget.attributes["data-id"].value;
        eventBus.trigger('newInstance', formId);
    }

    showFormInfo(ev){
        const formId = ev.currentTarget.attributes["formId"].value;

        if( formId === 'none'){
            return;
        }

        $('ul.select-list li').removeClass('selected');
        $(ev.currentTarget).addClass('selected');
    }

    goToForms(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("loadFormsView");
    }

    render() {
        this.$el.html(this.template(this.model.toJSON()));

        this.delegateEvents();
        return this;
    }

    refresh(){

        // Check for changes if there are any and show warning modal...

        // Find current form ID
        eventBus.trigger(constants.EV_REFRESH_EDIT_FORMS_DASHBOARD);
    }
}

export default EditFormsDashboardView;